'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var Utils = require('./Utils.js');
var MaterialCardElement = require('./MaterialCardElement.js');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _dec2, _class;
var styles = {
  fullWidthButton: {
    width: '100%'
  }
};
var CreditCardEntry = (_dec = withStyles(styles), _dec2 = Utils.withStripe(), _dec(_class = _dec2(_class =
/*#__PURE__*/
function (_Component) {
  inherits(CreditCardEntry, _Component);

  function CreditCardEntry(props) {
    var _this;

    classCallCheck(this, CreditCardEntry);

    _this = possibleConstructorReturn(this, getPrototypeOf(CreditCardEntry).call(this, props));
    _this.state = {
      name: '',
      postalCode: '',
      showErrorText: false
    };
    return _this;
  }

  createClass(CreditCardEntry, [{
    key: "tokenizer",
    value: function tokenizer() {
      var _this2 = this;

      this.props.stripe.createToken({
        name: this.state.name
      }).then(function (_ref) {
        var token = _ref.token;
        var validToken = ObjectHelper.isPresent(token);

        if (validToken) {
          _this2.props.onSuccessfulTokenized(token);
        }

        _this2.setState({
          showErrorText: !validToken
        });
      });
    }
  }, {
    key: "handleSubmitCreditCard",
    value: function handleSubmitCreditCard() {
      this.props.onSubmitClicked();
      this.tokenizer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default["default"].createElement(Grid, {
        container: true,
        spacing: 16
      }, React__default["default"].createElement(Grid, {
        item: true,
        xs: 12
      }, React__default["default"].createElement(TextField["default"], {
        fullWidth: true,
        label: "Name on card",
        onChange: function onChange(event) {
          _this3.setState({
            name: event.target.value,
            showErrorText: false
          });
        }
      })), React__default["default"].createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6
      }, React__default["default"].createElement(MaterialCardElement.MaterialCardNumberElement, {
        labelName: "Card number"
      })), React__default["default"].createElement(Grid, {
        item: true,
        xs: true,
        sm: 2
      }, React__default["default"].createElement(MaterialCardElement.MaterialCardExpiryElement, {
        labelName: "Exp date"
      })), React__default["default"].createElement(Grid, {
        item: true,
        xs: true,
        sm: 2
      }, React__default["default"].createElement(MaterialCardElement.MaterialCardCVCElement, {
        labelName: "CVC"
      })), React__default["default"].createElement(Grid, {
        item: true,
        xs: true,
        sm: 2
      }, React__default["default"].createElement(MaterialCardElement.MaterialPostalCodeElement, {
        labelName: "Postal code"
      })), this.state.showErrorText && React__default["default"].createElement(Grid, {
        item: true,
        xs: 12
      }, React__default["default"].createElement(Typography["default"], null, this.props.errorText)), React__default["default"].createElement(Grid, {
        item: true,
        xs: 12,
        style: {
          textAlign: this.props.addCardButtonPosition
        }
      }, React__default["default"].createElement(Button["default"], {
        variant: "contained",
        color: "primary",
        fullWidth: this.props.addCardButtonFullWidth,
        onClick: this.handleSubmitCreditCard.bind(this),
        disabled: ObjectHelper.isBlank(this.state.name) || this.props.submitting
      }, this.props.addCardButtonText)));
    }
  }]);

  return CreditCardEntry;
}(React.Component)) || _class) || _class);
CreditCardEntry.defaultProps = {
  errorText: '',
  addCardButtonText: 'Update card',
  addCardButtonFullWidth: false,
  addCardButtonPosition: 'right',
  submitting: false,
  onSubmitClicked: function onSubmitClicked() {},
  onSuccessfulTokenized: function onSuccessfulTokenized() {}
};

module.exports = CreditCardEntry;
